{
  "version": 1,
  "asset_id": "bdc27e40-4abc-466c-8def-71d0ef686b3c",
  "project_id": "a02fcdc8-85b3-464c-ad34-cd455060bb51",
  "url": "/__l5e/assets-v1/bdc27e40-4abc-466c-8def-71d0ef686b3c/footer-ad-video.mp4",
  "r2_key": "a/v1/a02fcdc8-85b3-464c-ad34-cd455060bb51/bdc27e40-4abc-466c-8def-71d0ef686b3c/footer-ad-video.mp4",
  "original_filename": "footer-ad-video.mp4",
  "size": 500213,
  "content_type": "video/mp4",
  "created_at": "2026-06-17T09:26:58Z"
}
